/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import fetchWrapper from "../../utils/fetchWrapper";
import { aemTemplatePath } from "../../utils/servicesUtils";

const initialState = {
  aemData: {},
  isContentLoading: false,
  isAEMDataLoaded: false,
};

export const fetchAemData = createAsyncThunk("aem/fetchData", async (userData, { rejectWithValue }) => {
  try {
    const aemData = await fetchWrapper(aemTemplatePath(), {}, true);
    return aemData;
  } catch (error) {
    console.error("Error fetching AEM data:", error);
    return rejectWithValue(error);
  }
});

const aemSlice = createSlice({
  name: "aem",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAemData.pending, (state) => {
        state.isContentLoading = true;
      })
      .addCase(fetchAemData.fulfilled, (state, action) => {
        const aemData = action.payload;
        state.aemData = aemData;
        state.isContentLoading = false;
        state.isAEMDataLoaded = true;
      })
      .addCase(fetchAemData.rejected, (state) => {
        state.isContentLoading = false;
      });
  },
});

const selectSelf = (state) => state?.aem;

const selectAemData = createSelector(selectSelf, (aem) => aem.aemData);

export const selectIsAemLoading = createSelector(selectSelf, (aem) => {
  return {
    isContentLoading: aem.isContentLoading,
    isAEMDataLoaded: aem.isAEMDataLoaded,
  };
});
export const selectConfirmationModalContent = createSelector(selectAemData, (aem) => {
  return {
    confirmationModal: aem?.confirmationModal || {},
  };
});
export const selectTransportStatusElements = createSelector(selectAemData, (aem) => {
  return {
    ltpTransportStatusSending: aem?.transportStatusElement?.ltpTransportStatusSending || "",
    ltpTransportStatusSentAt: aem?.transportStatusElement?.ltpTransportStatusSentAt || "",
    ltpTransportStatusFailed: aem?.transportStatusElement?.ltpTransportStatusFailed || "",
    ltpTransportErrorButtonText: aem?.transportStatusElement?.ltpTransportErrorButtonText || "",
  };
});
export const selectChatMessages = createSelector(selectAemData, (aem) => {
  return {
    ltpAgentConnectedText: aem?.chatMessages?.ltpAgentConnectedText || "",
    ltpAgentLeftText: aem?.chatMessages?.ltpAgentLeftText || "",
    ltpChatEndedText: aem?.chatMessages?.ltpChatEndedText || "",
    ltpLoadingMessagesText: aem?.chatMessages?.ltpLoadingMessagesText || "",
  };
});
export const selectChatContainerContent = createSelector(selectAemData, (aem) => {
  return {
    ltpHeaderText: aem?.chatContainer?.ltpHeaderText || "",
    ltpChatErrorText: aem?.chatContainer?.ltpChatErrorText || "",
    ltpChatErrorEndChatText: aem?.chatContainer?.ltpChatErrorEndChatText || "",
    ltpChatEndText: aem?.chatContainer?.ltpChatEndText || "",
  };
});
export default aemSlice.reducer;
